import React from "react";
import clsx from "clsx";
import TableHeader from "./components/TableHeader";
import TableRow from "./components/TableRow";
import TableCell from "./components/TableCell";
import { TableProps, TableTheme } from "./types";
import {
  MAP_TABLE_THEME_TO_CLASSNAME,
  MAP_TABLE_THEME_TO_HEADER_DIVIDE,
  MAP_TABLE_THEME_TO_BODY_DIVIDE,
} from "./helpers";

const Table: React.FC<TableProps> = ({
  headers,
  rows,
  theme = TableTheme.dark,
  hasHeaderDivide,
  className,
}) => {
  return (
    <div className={clsx(className)}>
      <div className="inline-block min-w-full align-middle">
        <div>
          <table
            className={clsx(
              "min-w-full",
              MAP_TABLE_THEME_TO_CLASSNAME[theme],
              hasHeaderDivide && MAP_TABLE_THEME_TO_HEADER_DIVIDE[theme],
            )}
          >
            <thead>
              <TableRow>
                {headers.map((header, i) => {
                  return (
                    <TableHeader
                      key={header.value + i}
                      value={header.value}
                      isHidden={header.isHidden}
                    />
                  );
                })}
              </TableRow>
            </thead>
            <tbody className={MAP_TABLE_THEME_TO_BODY_DIVIDE[theme]}>
              {rows.map((row, rI) => {
                const rowKey = "row" + rI;
                return (
                  <TableRow key={rowKey}>
                    {headers.map((header, hI) => {
                      const cellKey = "cell" + hI;

                      const cellValue = row.find(
                        (item) => item.key === header.value,
                      );

                      const cellClassName = header.isHidden
                        ? "w-full text-right"
                        : "";

                      if (!cellValue) return null;
                      return (
                        <TableCell
                          key={rowKey + cellKey}
                          value={cellValue}
                          className={cellClassName}
                        />
                      );
                    })}
                  </TableRow>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
